import { render, staticRenderFns } from "./trendList.vue?vue&type=template&id=49410fc7&scoped=true"
import script from "./trendList.vue?vue&type=script&lang=js"
export * from "./trendList.vue?vue&type=script&lang=js"
import style0 from "../../../style/common-pc.scss?vue&type=style&index=0&id=49410fc7&prod&lang=scss&scoped=true&external"
import style1 from "./trendList.vue?vue&type=style&index=1&id=49410fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49410fc7",
  null
  
)

export default component.exports